<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled">
  <nb-option *ngIf="showEmptyOption" [value]="''">Alle</nb-option>
  <nb-option *ngFor="let checkpointGroup of checkpointGroups()"
             [value]="checkpointGroup.id">
    ({{checkpointGroup.number}}) {{checkpointGroup.name}}
  </nb-option>
</nb-select>
